import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSorting = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.61 6.057v7.693a.516.516 0 1 0 1.03 0V6.057l1.87 1.87a.516.516 0 1 0 .73-.73l-2.605-2.603a.718.718 0 0 0-.085-.073.515.515 0 0 0-.85 0 .718.718 0 0 0-.085.073L12.01 7.198a.516.516 0 1 0 .73.73l1.87-1.87ZM6.874 7.734c.285 0 .516.231.516.516v7.693l1.87-1.87a.516.516 0 1 1 .729.73l-2.605 2.603a.726.726 0 0 1-.085.073.515.515 0 0 1-.85 0 .726.726 0 0 1-.085-.073L3.76 14.802a.516.516 0 1 1 .73-.73l1.87 1.87V8.25c0-.285.23-.516.515-.516Z",
		clipRule: "evenodd"
	})
});
export { SvgSorting as ReactComponent };
